(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Check URL for customer_posted param
  var params = new URLSearchParams(window.location.search);
  if (params.get("customer_posted") === "true") {
    var successDiv = document.getElementById("newsletter-success");
    if (successDiv) {
      successDiv.style.display = "block";
      // Scroll to newsletter section
      successDiv.scrollIntoView({ behavior: "smooth" });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-homepage"] && !Shopify.designMode) return;
  try {
    
"use strict";
(function () {
  if (customElements.get("products-homepage")) return;

  class ProductsHomepage extends HTMLElement {
    #sectionId = null;
    #atcBtns = [];
    #onLoad = null;

    // =================================================================
    // LIFECYCLE
    // =================================================================

    connectedCallback() {
      this.#sectionId = this.dataset.sectionId;
      this.#setupElements();
      this.#attachEventListeners();
      this.#maybeOpenCart();
    }

    disconnectedCallback() {
      this.#detachEventListeners();
    }

    // =================================================================
    // INITIALIZATION
    // =================================================================

    #setupElements() {
      this.#atcBtns = [...this.querySelectorAll(".scoped-add-to-cart")];
    }

    // =================================================================
    // EVENT LISTENERS
    // =================================================================

    #attachEventListeners() {
      this.#atcBtns.forEach((btn) =>
        btn.addEventListener("click", this.#handleAtcClick),
      );

      this.#onLoad = this.#maybeOpenCart.bind(this);
      window.addEventListener("load", this.#onLoad);
    }

    #detachEventListeners() {
      this.#atcBtns.forEach((btn) =>
        btn.removeEventListener("click", this.#handleAtcClick),
      );

      if (this.#onLoad) {
        window.removeEventListener("load", this.#onLoad);
        this.#onLoad = null;
      }
    }

    // =================================================================
    // HANDLERS
    // =================================================================

    #handleAtcClick = async (e) => {
      const btn = e.currentTarget;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        sessionStorage.setItem("openCartAfterReload", "true");
        window.location.reload();
      } catch (err) {
        console.error(err);
        alert("Failed to add product");
        btn.disabled = false;
      }
    };

    // =================================================================
    // CART
    // =================================================================

    #maybeOpenCart() {
      if (!sessionStorage.getItem("openCartAfterReload")) return;
      sessionStorage.removeItem("openCartAfterReload");

      setTimeout(() => {
        const trigger = document.querySelector(
          '[data-testid="cart-drawer-trigger"]',
        );
        trigger?.click();
      }, 300);
    }
  }

  customElements.define("products-homepage", ProductsHomepage);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopify-main-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById("slidesContainer");
    if (!container) {
      return;
    }
    const autoScroll = container.dataset.autoScroll == "true";
    const scrollSpeed = +container.dataset.scrollSpeed;
    const slides = container.querySelectorAll(".slide");
    const dotsContainer = document.getElementById("sliderDots");

    let index = 0;
    let interval;

    function goToSlide(i) {
      index = i;
      if (!container) {
        return;
      }

      container.style.transform = `translateX(-${i * 100}%)`;

      if (dotsContainer) {
        dotsContainer
          .querySelectorAll(".slider-dot")
          .forEach((d) => d.classList.remove("active"));
        if (dotsContainer.children[i]) {
          dotsContainer.children[i].classList.add("active");
        }
      }
    }

    if (dotsContainer) {
      slides.forEach((_, i) => {
        const dot = document.createElement("span");
        dot.className = "slider-dot" + (i === 0 ? " active" : "");
        dot.onclick = () => goToSlide(i);
        dotsContainer.appendChild(dot);
      });
    }

    if (autoScroll) {
      function startAuto() {
        interval = setInterval(() => {
          goToSlide((index + 1) % slides.length);
        }, scrollSpeed);
      }
      startAuto();

      container.addEventListener("mouseenter", () => clearInterval(interval));
      container.addEventListener("mouseleave", startAuto);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
